import UnderImg from '../../../assets/under-construction.png';
import { suppComp } from "../../../script/comp-data";
import './in-comp-page.scss';

export default function InCompPage() {
    return (
        <>     
        <div className={'fw-content-header'}>작업중</div>
        <div id={'fw-page-content'}>
            <div className={'fw-unde-cons-container'}>
                <div className={'fw-unde-cons-header'}>
                    <img src={suppComp.logo} alt={suppComp.snam} />
                    <div className={'fw-unde-header-title'}>{suppComp.snam}</div>
                </div>
                <div className={'fw-unde-cons-body'}>
                    <div className={'fw-unde-detail-wrapper'}>
                        <div className={'fw-unde-detail-title'}>페이지 제작중</div>
                        <div className={'fw-unde-detail-detail'}>
                            죄송합니다. 현재 이 페이지는 제작 중입니다. 곧 완성하여 찾아뵙겠습니다.
                        </div>
                    </div>
                    <figure className={'fw-unde-img-wrapper'}>
                        <img src={UnderImg} alt="페이지 제작 중" />
                    </figure>                          
                </div>          
            </div>
        </div>        
        </>
    )
}